import type { TokenHandshakeHandler } from './types'
import { completeTokenHandshakeAuth } from '../token-handshake-guards'
import { applyAccessFromParams } from './resolve-access-from-params'

export const gridcardHandler: TokenHandshakeHandler = async (params, { authStore, router }) => {
	const code = String(params?.code || '').trim()

	if (!code) {
		return {
			error: { code: -32602, message: 'Invalid params' }
		}
	}

	await authStore.loginGrid({
		confirm_code: code
	})

	const accessError = await applyAccessFromParams(params, authStore, {
		mode: 'fallback',
		logoutOnMismatch: true
	})
	if (accessError) return accessError

	void completeTokenHandshakeAuth(router)

	return {
		result: 1
	}
}
